import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import meetingImage from '../assets/schedule/face-to-face-meeting.jpg';

const BLOCK_KEYS = [
  { title: 'website.faceToFace.privateTitle', body: 'website.faceToFace.privateBody' },
  { title: 'website.faceToFace.b2bTitle', body: 'website.faceToFace.b2bBody' },
  { title: 'website.faceToFace.govTitle', body: 'website.faceToFace.govBody' },
  { title: 'website.faceToFace.sectorTitle', body: 'website.faceToFace.sectorBody' },
];

const FaceToFaceMeetings = () => {
  const { t, isRTL } = useLanguage();

  return (
    <div
      className="relative overflow-hidden bg-white"
      dir={isRTL ? 'rtl' : 'ltr'}
      style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
    >
      <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center gap-14 px-6 py-16 sm:px-10 sm:py-20 lg:gap-20 lg:px-16 lg:py-28">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.55 }}
          className="flex w-full flex-col items-center gap-3"
        >
          <h2
            className="w-full text-center text-[32px] font-bold sm:text-[36px] lg:text-[40px]"
            style={{ color: '#004057', lineHeight: 1.2 }}
          >
            {t('website.faceToFace.title')}
          </h2>
          <p
            className="max-w-[702px] text-center text-base font-normal"
            style={{ color: '#004057', lineHeight: '24px' }}
          >
            {t('website.faceToFace.subtitle')}
          </p>
        </motion.div>

        <div className="flex w-full flex-col items-stretch gap-12 lg:flex-row lg:items-center lg:gap-16 xl:gap-20">
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.5, delay: 0.08 }}
            className="flex min-w-0 flex-1 flex-col gap-8"
          >
            <div className="grid grid-cols-1 gap-8 sm:gap-y-8 lg:grid-cols-2 lg:gap-x-6">
              {BLOCK_KEYS.map((keys) => (
                <div key={keys.title} className="flex flex-col gap-4 py-1">
                  <h3
                    className="text-xl font-bold sm:text-2xl"
                    style={{ color: '#51516B', lineHeight: 1.4 }}
                  >
                    {t(keys.title)}
                  </h3>
                  <p className="text-base font-normal" style={{ color: '#51516B', lineHeight: '24px' }}>
                    {t(keys.body)}
                  </p>
                </div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.5, delay: 0.12 }}
            className="relative w-full min-w-0 flex-1"
          >
            <img
              src={meetingImage}
              alt={t('website.faceToFace.imageAlt')}
              className="h-auto w-full max-h-[min(640px,85vh)] rounded-[40px] object-cover shadow-md sm:rounded-[48px] lg:rounded-[53px]"
              loading="lazy"
              decoding="async"
            />
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default FaceToFaceMeetings;
